import React, { createContext, useContext, useState } from "react";
import { IMemberProfile } from "../../interface/analysed";
import { getCurrentFinancialYear } from "../../utils/commonUtil";

interface FilterSelectionContextType {
  selectedProfiles: IMemberProfile[];
  setSelectedProfiles: React.Dispatch<React.SetStateAction<IMemberProfile[]>>;
  selectedEntityId: number;
  setSelectedEntityId: React.Dispatch<React.SetStateAction<number>>;
  isShowingTotals: boolean;
  setIsShowingTotals: React.Dispatch<React.SetStateAction<boolean>>;
  selectedYear: number;
  setSelectedYear: React.Dispatch<React.SetStateAction<number>>;
}

const FilterSelectionContext = createContext<FilterSelectionContextType | undefined>(undefined);

export const FilterSelectionProvider: React.FC<{ children: React.ReactNode; initialEntityId?: number }> = ({
  children,
  initialEntityId,
}) => {
  const [selectedProfiles, setSelectedProfiles] = useState<IMemberProfile[]>([]);
  const [selectedEntityId, setSelectedEntityId] = useState<number>(initialEntityId ?? 0);
  const [isShowingTotals, setIsShowingTotals] = useState<boolean>(true);
  const [selectedYear, setSelectedYear] = useState<number>(Number(getCurrentFinancialYear()));

  return (
    <FilterSelectionContext.Provider
      value={{
        selectedProfiles,
        setSelectedProfiles,
        selectedEntityId,
        setSelectedEntityId,
        isShowingTotals,
        setIsShowingTotals,
        selectedYear,
        setSelectedYear,
      }}
    >
      {children}
    </FilterSelectionContext.Provider>
  );
};

export const useFilterSelection = () => {
  const context = useContext(FilterSelectionContext);
  if (!context) {
    throw new Error("useFilterSelection must be used within a FilterSelectionProvider");
  }
  return context;
};
